export default __webpack_public_path__ + "static/media/3-column-preview-card.c0359064.png";